import { render, staticRenderFns } from "./youjia.vue?vue&type=template&id=507916c0&scoped=true"
import script from "./youjia.vue?vue&type=script&lang=js"
export * from "./youjia.vue?vue&type=script&lang=js"
import style0 from "./youjia.vue?vue&type=style&index=0&id=507916c0&prod&scoped=true&lang=less"
import style1 from "./youjia.vue?vue&type=style&index=1&id=507916c0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507916c0",
  null
  
)

export default component.exports